export enum AnalyticsTrackTypeConstants {
  TRACK = 'track',
  PORTFOLIO = 'portfolio',
}
